import React, { useEffect, useState, useRef } from "react"
import { Container, Button, Card, Table, Form } from "react-bootstrap"
import { db } from "./../firebase"
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
  getDoc,
  doc,
  updateDoc,
} from "firebase/firestore"
import { getFunctions, httpsCallable } from "firebase/functions"
import Navigation from "./Navigation"

export default function Admin() {
  const [users, setUsers] = useState([])
  const emailRef = useRef()
  const functions = getFunctions()

  // ===============================
  // Get data
  // ===============================

  const currentData = query(
    collection(db, "users"),
    where("subscription", "==", true)
  )

  // Hook for paid users
  useEffect(() => {
    const unsubCol = onSnapshot(currentData, (snapshot) => {
      setUsers(snapshot.docs.map((doc) => doc.data()))
    })
    return () => unsubCol()
  }, [])

  // ===============================
  // Functions
  // ===============================

  // Cloud Functions
  const addAdminRole = httpsCallable(functions, "addAdminRole")
  const removeAdminRole = httpsCallable(functions, "removeAdminRole")
  const getUID = httpsCallable(functions, "getUID")

  // Function to get update Admin field in Firestore
  const updateAdmin = async (uid, value) => {
    const docRef = doc(db, "users", uid)
    await updateDoc(docRef, "admin", value)
  }

  // onClick Add Admin Role
  async function handleAddAdmin(e, email) {
    e.preventDefault()

    addAdminRole({ email: email }).then((result) => {
      alert(result.data.message)
    })

    getUID({ email: email }).then((response) => {
      updateAdmin(response.data.uid, true)
    })
  }

  // On Click Remove Admin Role
  async function handleRemoveAdmin(e, email) {
    e.preventDefault()
    removeAdminRole({ email: email }).then((result) => {
      alert(result.data.message)
    })

    getUID({ email: email }).then((response) => {
      updateAdmin(response.data.uid, false)
    })
  }

  // ===============================
  // Filter data
  // ===============================
  const paidQR = users.filter((item) => item.paymentType === "QR")
  const paidInvitado = users.filter((item) => item.paymentType === "Invitado")
  const paidPaypal = users.filter((item) => item.paymentType === "PayPal")
  const paidEfectivo = users.filter((item) => item.paymentType === "Efectivo")
  const paidDeposito = users.filter((item) => item.paymentType === "Deposito")

  //
  const totalExpositor = users.filter(
    (item) => item.category === "Expositor"
  ).length

  const totalStudent = users.filter(
    (item) => item.category === "Student"
  ).length

  const totalProfessional = users.filter(
    (item) => item.category === "Professional"
  ).length

  const qrExpositor = paidQR.filter(
    (item) => item.category === "Expositor"
  ).length
  const qrStudent = paidQR.filter((item) => item.category === "Student").length
  const qrProfessional = paidQR.filter(
    (item) => item.category === "Professional"
  ).length

  const paypalExpositor = paidPaypal.filter(
    (item) => item.category === "Expositor"
  ).length
  const paypalStudent = paidPaypal.filter(
    (item) => item.category === "Student"
  ).length
  const paypalProfessional = paidPaypal.filter(
    (item) => item.category === "Professional"
  ).length

  const efectivoExpositor = paidEfectivo.filter(
    (item) => item.category === "Expositor"
  ).length
  const efectivoStudent = paidEfectivo.filter(
    (item) => item.category === "Student"
  ).length
  const efectivoProfessional = paidEfectivo.filter(
    (item) => item.category === "Professional"
  ).length

  const depositoExpositor = paidDeposito.filter(
    (item) => item.category === "Expositor"
  ).length
  const depositoStudent = paidDeposito.filter(
    (item) => item.category === "Student"
  ).length
  const depositoProfessional = paidDeposito.filter(
    (item) => item.category === "Professional"
  ).length

  const invitadoExpositor = paidInvitado.filter(
    (item) => item.category === "Expositor"
  ).length
  const invitadoStudent = paidInvitado.filter(
    (item) => item.category === "Student"
  ).length
  const invitadoProfessional = paidInvitado.filter(
    (item) => item.category === "Professional"
  ).length

  // ===============================
  // HTML
  // ===============================

  return (
    <>
      <Navigation />
      <Container
        className='align-items-center justify-content-center mt-4'
        style={{ maxWidth: "600px" }}
      >
        <h2 className='mb-4'>Panel de Administración</h2>

        {/* Uncomments for MAKE ADMIN  */}
        {/* <div className='d-flex justify-content-around'>
          <Form className='m-2 w-75'>
            <Form.Group id='admin-email'>
              <Form.Label>Email</Form.Label>
              <Form.Control type='email' ref={emailRef} required />
            </Form.Group>
            <div className='d-flex justify-content-between'>
              <Button
                className='w-200 mt-2'
                variant='success'
                onClick={(e) => handleAddAdmin(e, emailRef.current.value)}
              >
                Asignar admin
              </Button>
              <Button
                className='w-200 mt-2'
                variant='danger'
                onClick={(e) => handleRemoveAdmin(e, emailRef.current.value)}
              >
                Quitar admin
              </Button>
            </div>
          </Form>
        </div> */}

        {/* style={{ width: '8rem' }} */}
        <div className='d-flex mt-5 mb-5 justify-content-around'>
          <div className='text-left fs-6 fw-bold'>
            Expositor
            <Card
              className=' bg-opacity-60 mb-3'
              style={{ backgroundColor: "#B4C5E4", width: "8rem" }}
            >
              <Card.Body>
                <div className='fs-6 w-100 fw-bold'>
                  <p>QR: {qrExpositor}</p>
                  <p>Paypal: {paypalExpositor}</p>
                  <p>Deposito: {depositoExpositor}</p>
                  <p>Efectivo: {efectivoExpositor}</p>
                  <p>Invitado: {invitadoExpositor}</p>
                </div>
              </Card.Body>
            </Card>
            <p className='text-center fs-3'>Total</p>
            <Card
              className='bg-opacity-60 mt-2 '
              style={{ backgroundColor: "#B4C5E4", width: "8rem" }}
            >
              <Card.Body>
                <div className='text-center fs-2 w-100 fw-bold'>
                  {totalExpositor}
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className='text-left fs-6 fw-bold mx-auto'>
            Estudiante
            <Card className='mb-3 bg-success ' style={{ width: "8rem" }}>
              <Card.Body>
                <div className='fs-6 w-100 fw-bold'>
                  <p>QR: {qrStudent}</p>
                  <p>Paypal: {paypalStudent}</p>
                  <p>Deposito: {depositoStudent}</p>
                  <p>Efectivo: {efectivoStudent}</p>
                  <p>Invitado: {invitadoStudent}</p>
                </div>
              </Card.Body>
            </Card>
            <p className='text-center fs-3'>Total</p>
            <Card
              className='bg-success bg-opacity-60 mt-2'
              style={{ width: "8rem" }}
            >
              <Card.Body>
                <div className='text-center fs-2 w-100 fw-bold'>
                  {totalStudent}
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className='text-left fs-6 fw-bold'>
            Profesionales
            <Card className='bg-warning mb-3' style={{ width: "8rem" }}>
              <Card.Body>
                <div className='fs-6 w-100 fw-bold'>
                  <p>QR: {qrProfessional}</p>
                  <p>Paypal: {paypalProfessional}</p>
                  <p>Deposito: {depositoProfessional}</p>
                  <p>Efectivo: {efectivoProfessional}</p>
                  <p>Invitado: {invitadoProfessional}</p>
                </div>
              </Card.Body>
            </Card>
            <p className='text-center fs-3'>Total</p>
            <Card
              className='bg-warning bg-opacity-60 mt-2'
              style={{ width: "8rem" }}
            >
              <Card.Body>
                <div className='text-center fs-2 w-100 fw-bold'>
                  {totalProfessional}
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </Container>

      <div className='container'>
        <h2 className='mt-5'>Inscripción Confirmada</h2>

        <h3 className='mt-5'>Expositores</h3>
        <Table striped bordered hover>
          {/* <table className='table table-striped mb-10'> */}
          <thead>
            <tr>
              <th scope='col' width={"5%"}>
                Paper Id
              </th>
              <th scope='col' width={"15%"}>
                Nombre
              </th>
              <th scope='col' width={"15%"}>
                Apellido
              </th>
              <th scope='col' width={"15%"}>
                Email
              </th>
              {/* <th scope="col" width={'10%'}>Pago</th> */}
              <th scope='col' width={"10%"}>
                Categoria
              </th>
              <th scope='col' width={"5%"}>
                Método de pago
              </th>
              <th scope='col' width={"10%"}>
                Fecha de pago
              </th>
              {/* <th scope='col' width={"15%"}>
                Último acceso
              </th> */}
            </tr>
          </thead>
          <tbody>
            {users &&
              users
                .filter((item) => item.category === "Expositor")
                .map((arrayData, index) => {
                  return (
                    <tr key={index}>
                      <td>{arrayData.paperID}</td>
                      <td>{arrayData.Name}</td>
                      <td>{arrayData.Surname}</td>
                      <td>{arrayData.email}</td>
                      <td>{arrayData.category}</td>
                      <td>{arrayData.paymentType}</td>
                      <td>{arrayData.lastPayment}</td>
                      {/* {arrayData.checkin !== null && <td>{arrayData.checkin}</td>} */}
                    </tr>
                  )
                })}

            {/* {console.log(users[0])} */}
          </tbody>
          {/* </table> */}
        </Table>

        <h3 className='mt-5'>Profesionales</h3>
        <Table striped bordered hover>
          {/* <table className='table table-striped mb-10'> */}
          <thead>
            <tr>
              <th scope='col' width={"5%"}>
                Paper Id
              </th>
              <th scope='col' width={"15%"}>
                Nombre
              </th>
              <th scope='col' width={"15%"}>
                Apellido
              </th>
              <th scope='col' width={"15%"}>
                Email
              </th>
              {/* <th scope="col" width={'10%'}>Pago</th> */}
              <th scope='col' width={"10%"}>
                Categoria
              </th>
              <th scope='col' width={"5%"}>
                Método de pago
              </th>
              <th scope='col' width={"10%"}>
                Fecha de pago
              </th>
              {/* <th scope='col' width={"15%"}>
                Último acceso
              </th> */}
            </tr>
          </thead>
          <tbody>
            {users &&
              users
                .filter((item) => item.category === "Professional")
                .map((arrayData, index) => {
                  return (
                    <tr key={index}>
                      <td>{arrayData.paperID}</td>
                      <td>{arrayData.Name}</td>
                      <td>{arrayData.Surname}</td>
                      <td>{arrayData.email}</td>
                      <td>{arrayData.category}</td>
                      <td>{arrayData.paymentType}</td>
                      <td>{arrayData.lastPayment}</td>
                      {/* {arrayData.checkin !== null && <td>{arrayData.checkin}</td>} */}
                    </tr>
                  )
                })}

            {/* {console.log(users[0])} */}
          </tbody>
          {/* </table> */}
        </Table>

        <h3 className='mt-5'>Estudiantes</h3>
        <Table striped bordered hover>
          {/* <table className='table table-striped mb-10'> */}
          <thead>
            <tr>
              <th scope='col' width={"5%"}>
                Paper Id
              </th>
              <th scope='col' width={"15%"}>
                Nombre
              </th>
              <th scope='col' width={"15%"}>
                Apellido
              </th>
              <th scope='col' width={"15%"}>
                Email
              </th>
              {/* <th scope="col" width={'10%'}>Pago</th> */}
              <th scope='col' width={"10%"}>
                Categoria
              </th>
              <th scope='col' width={"5%"}>
                Método de pago
              </th>
              <th scope='col' width={"10%"}>
                Fecha de pago
              </th>
              {/* <th scope='col' width={"15%"}>
                Último acceso
              </th> */}
            </tr>
          </thead>
          <tbody>
            {users &&
              users
                .filter((item) => item.category === "Student")
                .map((arrayData, index) => {
                  return (
                    <tr key={index}>
                      <td>{arrayData.paperID}</td>
                      <td>{arrayData.Name}</td>
                      <td>{arrayData.Surname}</td>
                      <td>{arrayData.email}</td>
                      <td>{arrayData.category}</td>
                      <td>{arrayData.paymentType}</td>
                      <td>{arrayData.lastPayment}</td>
                      {/* {arrayData.checkin !== null && <td>{arrayData.checkin}</td>} */}
                    </tr>
                  )
                })}

            {/* {console.log(users[0])} */}
          </tbody>
          {/* </table> */}
        </Table>
      </div>
    </>
  )
}
